import { getRoot, types } from 'mobx-state-tree';
import { createThunk, ListModel, model } from 'mst-collection';

import { NotificationModel } from './NotificationModel';
import { Api, schemas } from '@api';
import type { RootModelType } from '../RootModel';

export class NotificationList extends ListModel(
  types.reference(NotificationModel),
  {
    schema: schemas.NotificationListSchema,
  },
) {
  get hasReadingInProgress() {
    return (
      this.markAllAsRead.inProgress ||
      this.array.some((item) => item.markAsRead.inProgress)
    );
  }

  fetch = createThunk(() => {
    return async function fetch(this: NotificationList) {
      const res = await Api.Notifications.getNotifications();

      this.set(res.data);
    };
  });

  markAllAsRead = createThunk(() => {
    return async function markAllAsRead(this: NotificationList) {
      if (this.first) {
        this.array.forEach((i) => i.setIsNew(false));
        getRoot<RootModelType>(this).notifications.setNewCount(0);

        await Api.Notifications.setMultipleAsRead({
          newestId: this.first.id,
        });

        if (this.array.length > 20) {
          this.removeManyByIds(this.array.slice(21).map((i) => i.id));
        }
      }
    };
  });
}

export const NotificationListModel = model(NotificationList);
